// extracted by mini-css-extract-plugin
export default {"button":"AddAdminButton_button__Pks5n","icon":"AddAdminButton_icon__Vf556","text":"AddAdminButton_text__Zo2rm"};